import React from "react";
import ProductList from "./ProductSections/ProductList";
import ProductCaseStudySection from "./ProductSections/ProductCaseStudy";
import Footer from "../components/Footer";

const Products: React.FC = () => {
  return (
    <div >
       <section>
        <ProductList />
      </section>
      {/* <section>
        <ProductCaseStudySection />
      </section> */}
      <section>
        <Footer />
      </section>
    </div>
  );
};

export default Products;
